<li
  *ngFor="let menuItem of dropdown"
  [ngClass]="{ dropdown: menuItem?.dropdown, divider: menuItem?.isSeparator, open: menuItem?.dropdownOpen }"
>
  <ng-container *ngIf="menuItem">
    <a class="mct-hide-gt-xs"
      *ngIf="menuItem.routerLink && !menuItem.dropdown && menuItem.hidden != true"
      [routerLink]="menuItem.routerLink"
      [queryParams]="(menuItem.queryParams ?? {})"
      
      data-toggle="collapse"
      data-target="#main-nav-collapse"
      target="_self"
      >{{ menuItem.noTranslate ? menuItem.title : (menuItem.title | translate) }}</a
    >
    <a class="mct-hide-lt-sm"
      *ngIf="menuItem.routerLink && !menuItem.dropdown && menuItem.hidden != true"
      [routerLink]="menuItem.routerLink"
      [queryParams]="(menuItem.queryParams ?? {})"
      
      target="_self"
      >{{ menuItem.noTranslate ? menuItem.title : (menuItem.title | translate) }}</a
    >
    <a
      *ngIf="menuItem.url && !menuItem.dropdown && menuItem.hidden != true"
      [href]="menuItem.url"
      [target]="menuItem.target || '_self'"
      (mouseenter)="refreshMenuItemUrl(menuItem)"
      >{{ menuItem.noTranslate ? menuItem.title : (menuItem.title | translate) }}</a
    >
    <a
      *ngIf="menuItem.dropdown && menuItem.hidden != true"
      class="dropdown-toggle"
      href=""
      role="button"
      aria-haspopup="true"
      aria-expanded="false"
      (click)="$event.preventDefault(); toggleMenuItemDropdown(menuItem)"
      >{{ menuItem.noTranslate ? menuItem.title : (menuItem.title | translate) }}<span class="caret"></span
    ></a>
    <a
      *ngIf="menuItem.click && menuItem.hidden != true"
      href="#"
      data-toggle="collapse"
      data-target="#main-nav-collapse"
      (click)="$event.preventDefault(); menuItem.click()"
      >{{ menuItem.noTranslate ? menuItem.title : (menuItem.title | translate) }}</a
    >
    <ul wl-nested-menu class="dropdown-menu" *ngIf="menuItem.dropdown" [dropdown]="menuItem.dropdown"></ul>
  </ng-container>
</li>
<ng-content></ng-content>
